import React from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { MentionsInput, Mention } from 'react-mentions';
import Loader from '../../../../../Components/Utility/Loader/Loader';

const defaultStyle = {
  control: {
    backgroundColor: '#fff',
    fontSize: 14,
    fontWeight: 'normal',
  },
  '&singleLine': {
    display: 'inline-block',
    width: 180,
    highlighter: {
      padding: 1,
    },
    input: {
      border: 'none',
      marginTop: 10,
    },
  },
  suggestions: {
    list: {
      backgroundColor: 'white',
      border: '1px solid rgba(0,0,0,0.15)',
      fontSize: 14,
      width: '300px',
    },
    item: {
      padding: '5px 15px',
      borderBottom: '1px solid rgba(0,0,0,0.15)',
      '&focused': {
        backgroundColor: '#f5f5f5',
      },
      color: '#000',
    },
  },
};

function ComponentMail({ toggle, mainState, handleOnChange, sendEmailToSupplier }) {
  const { emailModal, toErr, bccErr, ccErr, to, bcc, cc, message, userList } = mainState;
  const { t } = useTranslation('common');

  const suggestedMentions = 'Suggested mentions';
  return (
    <Modal onHide={toggle} show={emailModal} size="lg">
      <Modal.Header>{t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.COMPONENT_MAIL.COMPOSE_EMAIL')}</Modal.Header>
      {mainState?.loader ? (
        <Loader />
      ) : (
        <Modal.Body>
          <div className="input-group form-floating-label fixed-label m-1 mt-3">
            <MentionsInput
              className="form-control"
              singleLine
              value={to}
              onChange={(_ev, _newValue, newPlainTextValue) => {
                handleOnChange(newPlainTextValue, 'to');
              }}
              style={defaultStyle}
              placeholder={t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.COMPONENT_MAIL.ADD_USE_INFO')}
              a11ySuggestionsListLabel={suggestedMentions}
            >
              <Mention trigger="@" data={userList} renderSuggestion={(val) => <div>{`${val.name} ${val.label}`}</div>} />
            </MentionsInput>
            <label>{t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.COMPONENT_MAIL.TO')}</label>
          </div>
          {toErr &&
            (to ? (
              <small className="error-message ml-1">{t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.COMPONENT_MAIL.PLEASE_ADD_EMAIL')}</small>
            ) : (
              <small className="error-message ml-1">
                {t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.COMPONENT_MAIL.PLEASE_ADD_ONE_EMAIL')}
              </small>
            ))}

          <div className="input-group form-floating-label fixed-label m-1 mt-3">
            <MentionsInput
              className="form-control"
              singleLine
              value={cc}
              onChange={(_ev, _newValue, newPlainTextValue) => {
                handleOnChange(newPlainTextValue, 'cc');
              }}
              style={defaultStyle}
              placeholder={t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.COMPONENT_MAIL.ADD_USER_CC')}
              a11ySuggestionsListLabel={suggestedMentions}
            >
              <Mention trigger="@" data={userList} renderSuggestion={(val) => <div>{`${val.name} ${val.label}`}</div>} />
            </MentionsInput>
            <label>{t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.COMPONENT_MAIL.CC')}</label>
          </div>
          {ccErr && (
            <small className="error-message ml-1">{t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.COMPONENT_MAIL.PLEASE_ADD_EMAIL')}</small>
          )}
          <div className="input-group form-floating-label fixed-label m-1 mt-3">
            <MentionsInput
              className="form-control"
              singleLine
              value={bcc}
              onChange={(_ev, _newValue, newPlainTextValue) => {
                handleOnChange(newPlainTextValue, 'bcc');
              }}
              style={defaultStyle}
              placeholder={t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.COMPONENT_MAIL.BCC_USER_EMAIL')}
              a11ySuggestionsListLabel={suggestedMentions}
            >
              <Mention trigger="@" data={userList} renderSuggestion={(val) => <div>{`${val.name} ${val.label}`}</div>} />
            </MentionsInput>
            <label>{t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.COMPONENT_MAIL.BCC')}</label>
          </div>
          {bccErr && (
            <small className="error-message ml-1">
              {t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.COMPONENT_MAIL.PLEASE_ADD_VALID_EMAIL')}
            </small>
          )}
          <div className="input-group form-floating-label fixed-label m-1 mt-3">
            <input value={message} type="text" name="name" className="form-control" onChange={(e) => handleOnChange(e.target.value, 'message')} />
            <label>{t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.COMPONENT_MAIL.MESSAGE')}</label>
          </div>

          <div className="modal-buttons mt-5 d-flex justify-content-between">
            <button onClick={toggle} type="button" className="btn btn-default">
              {t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.COMPONENT_MAIL.CANCEL')}
            </button>
            <button type="button" className="btn btn-default" onClick={() => sendEmailToSupplier()}>
              {t('PURCHASE_ORDER_LIST.PURCHASE_ORDER_DETAILS.ALL_RENDER_TABLE.COMPONENT_MAIL.SEND')}
            </button>
          </div>
        </Modal.Body>
      )}
    </Modal>
  );
}

export default ComponentMail;
